import { Control, Controller, RegisterOptions } from "react-hook-form";
import { NoxusFormLabel } from "@/components/Form/NoxusFormLabel";
import { Combobox } from "@/components/shadcn/combobox";

type KBOptionType = {
  value: string;
  label: string;
  description?: string;
  sources?: string[];
  type?: "temporary" | "entity";
};

interface ISpotSelect {
  value?: string | { label: string; value: string };
  placeholder?: string;
  options: KBOptionType[];
  label?: string;
  tooltip?: string;
  defaultValue?: KBOptionType;
  isLoading?: boolean;
  isDisabled?: boolean;
  isClearable?: boolean;
  onChange?: (value: any) => void;
  onBlur?: (value: any) => void;
  name?: string;
}
interface ISpotSelectFieldProps {
  name: string;
  placeholder?: string;
  label?: string;
  tooltip?: string;
  options: KBOptionType[];
  rules?: RegisterOptions;
  control: Control<any>;
  isClearable?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  onChange?: (value: string) => void;
  defaultValue?: string;
}

const KnowledgeSpotSelect = ({
  value,
  options,
  placeholder,
  label,
  tooltip,
  onChange,
  isLoading = false,
  isDisabled = false,
  isClearable = false,
  defaultValue,
  name,
}: ISpotSelect) => {
  const parsedValue =
    typeof value === "string" ? options.find((o) => o.value === value) : value;

  return (
    <div className="w-full">
      {label && <NoxusFormLabel label={label} tooltip={tooltip} name={name} />}

      <Combobox
        key={`select-field-${label}-${parsedValue?.value}`}
        options={options}
        value={parsedValue?.value}
        onValueChange={onChange}
        loading={isLoading}
        placeholder={placeholder}
        disabled={isDisabled}
        clearable={isClearable}
      />
    </div>
  );
};

export const KnowledgeBaseSpotSelectField = (props: ISpotSelectFieldProps) => {
  const defaultValue = props.options.find(
    (option) => option.value === props.defaultValue
  );
  return (
    <Controller
      control={props.control}
      name={props.name}
      defaultValue={props.defaultValue}
      rules={props.rules}
      render={({ field: { onChange, value, onBlur } }) => {
        const handleChange = (value: any) => {
          if (!value) {
            if (props.onChange) props.onChange("");
            onChange("");
            return;
          }
          onChange(Object.keys(value).includes("value") ? value?.value : value);
          if (props.onChange) props.onChange(value.value);
        };

        return (
          <KnowledgeSpotSelect
            value={value}
            label={props.label}
            options={props.options}
            tooltip={props.tooltip}
            placeholder={props.placeholder}
            isDisabled={props.isDisabled}
            defaultValue={defaultValue}
            isLoading={props.isLoading}
            isClearable={props.isClearable}
            onChange={handleChange}
            onBlur={onBlur}
          />
        );
      }}
    />
  );
};
